module.exports = __webpack_public_path__ + "static/media/report.f1fa5025.svg";